import { createFileRoute } from "@tanstack/react-router";
import { MaintenancePage } from "@/components/ui/maintenance-page";

export const Route = createFileRoute("/502")({
	component: MaintenanceRoute,
});

function MaintenanceRoute() {
	return <MaintenancePage />;
}
